import { render, staticRenderFns } from "./BuySell.vue?vue&type=template&id=34368583&scoped=true"
var script = {}
import style0 from "./BuySell.vue?vue&type=style&index=0&id=34368583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34368583",
  null
  
)

export default component.exports